import React from 'react';
import { IconButton, styled } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import history from 'services/history';

const Container = styled('div')(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.down('sm')]: {
    display: 'flex',
  },
}));

// Botão "+" da Appbar no celular; no desktop a tela usa o botão do cabeçalho da página.
const NewRecordAction: React.FC<{ to: string }> = ({ to }) => (
  <Container>
    <IconButton color="inherit" aria-label="Novo" onClick={() => history.push(to)}>
      <AddIcon />
    </IconButton>
  </Container>
);

export default NewRecordAction;
